import type { GraphLayoutButtonTooltipPayload } from 'components/Graph/GraphTooltip/GraphTooltipPayload';
import { useLocale } from 'containers/App/LocaleContext';
import { type FC, memo } from 'react';
import { TOOLTIP_CONTENT_WRAPPER_CLASS } from '../constants';

interface Props {
  payload: GraphLayoutButtonTooltipPayload;
}

const BareGraphSaveUserDefinedLayoutTooltip: FC<Props> = (props) => {
  const msg = useLocale();

  return (
    <div className={TOOLTIP_CONTENT_WRAPPER_CLASS}>
      {props.payload.unsaved
        ? msg.canvasGraph.saveOrChangeLayoutTooltip
        : msg.canvasGraph.changeLayoutTooltip}
    </div>
  );
};

export const GraphLayoutButtonTooltip = memo(
  BareGraphSaveUserDefinedLayoutTooltip,
);
